import React, { createContext, useContext, useEffect, useState } from 'react';

const AppTypeContext = createContext();

export const useAppType = () => useContext(AppTypeContext);

export const AppTypeProvider = ({ children }) => {
  const [appType, setAppType] = useState(() => {
    // Determine app type based on current URL
    const path = window.location.pathname;
    if (path.startsWith('/employer')) {
      return 'employer';
    }
    
    // Fallback to sessionStorage, then default to intern
    const savedState = sessionStorage.getItem('appType');
    return savedState || 'intern';
  });

  const switchAppType = (type) => {
    setAppType(type);
    sessionStorage.setItem('appType', type);
  };

  // Listen for URL changes and update appType accordingly
  useEffect(() => {
    const handleLocationChange = () => {
      const path = window.location.pathname;
      const newAppType = path.startsWith('/employer') ? 'employer' : 'intern';
      
      if (newAppType !== appType) {
        setAppType(newAppType);
        sessionStorage.setItem('appType', newAppType);
      }
    };

    // Listen for browser back/forward buttons
    window.addEventListener('popstate', handleLocationChange);
    
    // Check on mount
    handleLocationChange();

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, [appType]);

  return (
    <AppTypeContext.Provider value={{ appType, switchAppType }}>
      {children}
    </AppTypeContext.Provider>
  );
};